// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ngkxmijuwwuerokmvdqu.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5na3htaWp1d3d1ZXJva212ZHF1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI5Nzg0MjksImV4cCI6MjA4ODU1NDQyOX0.VKop9cRjTnGUGOXZ59drE8p1sfEKS2raDV1uTB12wAw";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});